import React, { useState, useEffect } from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { greeting } from "../../portfolio.js";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA2H3KftdnmPb6cVoP5ahRuNZmzwSGz5gw",
  authDomain: "protfolio-c166a.firebaseapp.com",
  projectId: "protfolio-c166a",
  storageBucket: "protfolio-c166a.appspot.com",
  messagingSenderId: "289881385119",
  appId: "1:289881385119:web:9269b6a6b3ba2b55019aaa",
};
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
export default function Footer(props) {
  const [visitorCount, setVisitorCount] = useState(0);
  useEffect(() => {
    const db = firebase.firestore();
    const visitorRef = db.collection("p_visitors").doc("count");

    console.log("incrementing visitor count...");

    // Increment the count field using a FieldValue.increment() operation
    visitorRef
      .update({ count: firebase.firestore.FieldValue.increment(1) })
      .then(() => {
        console.log("visitor count incremented");
      })
      .catch((error) => {
        console.log("error incrementing visitor count:", error);
      });

    // Listen for changes to the count field
    const unsubscribe = visitorRef.onSnapshot((doc) => {
      const data = doc.data();
      if (data) {
        setVisitorCount(data.count);
      }
    });

    return unsubscribe;
  }, []);
  return (
    <div className="footer-div">
      <Fade>
        <p className="footer-text" style={{ color: props.theme.secondaryText }}>
          Made with <span role="img">❤️</span> by {greeting.title}
        </p>
        <p className="footer-text" style={{ color: props.theme.secondaryText }}>
          {visitorCount} visitors have viewed my protfolio.
        </p>
      </Fade>
    </div>
  );
}
